<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <Affix>
      <div class="seach-bar-container full-box">
        <div
          class="logo"
          @click="reload"
        >
          <router-link to="/">
            <img
              class="logo-img"
              src="/static/img/logo.png"
            />
          </router-link>
        </div>
        <div class="search-wrap">
          <div class="search-box">
            <div class="input-box">
              <Icon type="ios-search"></Icon>
              <input
                name="txtSearchKeyword"
                placeholder="请输入产品名称 品牌 型号 订货编码"
                class="text ui-autocomplete-input"
                v-model="currentSearchKey"
                autocomplete="off"
              />
            </div>
            <!-- <span class="search-btn">搜 索</span> -->
            <Button
              type="primary"
              size="large"
              class="search-btn"
              @click.stop="onSearchKeyChanged"
              @keyup.enter="onSearchKeyChanged"
            >
              搜 索
            </Button>
          </div>
        </div>
        <div class="btn-groups">
          <div v-show="!isLogged">
            <Button
              type="primary"
              ghost
            >
              登录
            </Button>
            <Button
              type="text"
              ghost
            >
              注册
            </Button>
          </div>
        </div>
      </div>
    </Affix>
  </div>
</template>

<script>
import '@/styles/components/home/affixSearch.scss';
import { mapState, mapActions } from 'vuex';
import EventBus, { EventName } from '@/utils/EventBus';
const prefix = 'cpt-affix-search';

export default {
  inject: { reloadBody: 'reloadBody' },
  name: 'AffixSearch',
  components: {
  },
  props: {
    offSetTop: 255
  },
  data () {
    return {
      prefix,
      currentSearchKey: ''
    };
  },
  created () {
  },
  computed: {
    ...mapState({
      isLogged: state => state.isLogged
    })
  },
  methods: {
    ...mapActions({
      loadCarouselItems: 'loadCarouselItems'
    }),
    onSearchKeyChanged () {
      const nextPath = '/productlist';
      const routerObj = {
        path: nextPath,
        query: { searchKeyword: this.currentSearchKey }
      };
      if (this.$route.path === nextPath) {
        console.log(EventName.product.onSearchKeywordChanged);
        EventBus.$emit(EventName.product.onSearchKeywordChanged, this.currentSearchKey);
      } else {
        console.log('onSearchKeyChanged');
        this.$router.push(routerObj);
      }
    },
    reload () {
      this.reloadBody();
    }
  },
  mounted () {
  },
  updated () {
  }
};
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/home/AffixSearch.vue